/**
 * exam
 */

import request from '../utils/request'

/**
 * save answer
 * @param data
 uint32 ID = 1;
 * @returns {Promise<AxiosResponse<T>>}
 */
const getInfoById = ID => {
  return request.httpGet('/qceit/exam/info', {ID})
}

export default {
  getInfoById,
}
